import { MapPin, Phone, Mail, MessageCircle, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const DIRECTIONS_URL =
  "https://www.google.com/maps/search/?api=1&query=Area%2083%2C%20Off%20Bannerghatta%20Road%2C%20Bengaluru%2C%20Karnataka%20560083";

export const LocationSection = () => (
  <section id="location" data-testid="location-section" className="bg-brand-champagne py-20 lg:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 sm:px-8 lg:grid-cols-2 lg:gap-20">
      <Reveal>
        <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.28em] text-brand-moss">Location</p>
        <h2 className="font-serif text-4xl font-light leading-[1.1] tracking-tight text-brand-licorice sm:text-5xl">
          Off Bannerghatta Road, Bengaluru
        </h2>
        <p className="mt-7 flex items-start gap-3 text-base leading-relaxed text-brand-licorice/75">
          <MapPin size={18} strokeWidth={1.5} className="mt-1 shrink-0 text-brand-brunswick" />
          No. 313, Off Bannerghatta Road, Bilwaradahalli, Shanbhoganahalli, Bengaluru, Karnataka 560083
        </p>
        <div className="mt-8 flex flex-col gap-4 text-base text-brand-licorice/80">
          <a href="tel:+918046396067" data-testid="location-phone" className="flex items-center gap-3 transition-opacity hover:opacity-60">
            <Phone size={17} strokeWidth={1.5} className="text-brand-brunswick" /> +91 80463 96067 <span className="text-brand-licorice/50">· Reservations</span>
          </a>
          <a
            href="https://wa.me/918884608383"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="location-whatsapp"
            className="flex items-center gap-3 transition-opacity hover:opacity-60"
          >
            <MessageCircle size={17} strokeWidth={1.5} className="text-brand-brunswick" /> +91 88846 08383 <span className="text-brand-licorice/50">· WhatsApp</span>
          </a>
          <a href="mailto:info@area83.in" data-testid="location-email" className="flex items-center gap-3 transition-opacity hover:opacity-60">
            <Mail size={17} strokeWidth={1.5} className="text-brand-brunswick" /> info@area83.in
          </a>
        </div>
        <a
          href={DIRECTIONS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="location-directions-link"
          className="mt-10 inline-flex items-center gap-2 border-b border-brand-licorice pb-1 text-[13px] font-semibold uppercase tracking-[0.16em] text-brand-licorice transition-opacity hover:opacity-60"
        >
          Get directions <ArrowUpRight size={16} strokeWidth={1.75} />
        </a>
      </Reveal>
      <Reveal delay={0.12}>
        <div className="overflow-hidden border border-brand-licorice/10">
          <iframe
            title="Map: Dune Villas at Area 83, Off Bannerghatta Road, Bengaluru"
            data-testid="location-map"
            src="https://maps.google.com/maps?q=Area%2083%2C%20Off%20Bannerghatta%20Road%2C%20Bengaluru%2C%20Karnataka%20560083&t=&z=13&ie=UTF8&iwloc=&output=embed"
            className="aspect-[4/3] w-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </Reveal>
    </div>
  </section>
);
